import { ITodoItem } from '../models/todo-item';

export const todos: Array<ITodoItem> = [
    {
        title: 'Milk',
        description: 'Need to buy milk',
        isDone: false
    },
    {
        title: 'Bread',
        description: 'Need to buy bread',
        isDone: false
    },
    {
        title: 'Butter',
        description: 'Need to buy a butter',
        isDone: false
    },
    {
        title: 'Cheese',
        description: 'Need to buy a cheese',
        isDone: false
    }
];
